// Small helpers shared by the course screens (CoursePage, LessonPage).
import { stripInline } from '@wds/astro-bot-shared/course/inline';
import type { CourseItemDto, CourseItemKind, CourseStateDto } from '../types/course';

type T = (k: string, o?: Record<string, unknown>) => string;

export function itemPath(kind: CourseItemKind, code: string): string {
  return `/course/${kind}/${code}`;
}

/** «Урок 5. Название» for a lesson, «Работа блока: Название» for a block exam. */
export function itemLabel(t: T, it: { kind: CourseItemKind; number: number | null; title: string }): string {
  const title = stripInline(it.title); // a label is plain text: no bold
  if (it.kind === 'exam') return t('item.exam', { title });
  return it.number == null ? title : t('item.lesson', { number: it.number, title });
}

/** The item right after `code` in course order when the learner may open it (done or current), else null. */
export function nextOpenItem(state: CourseStateDto | undefined, code: string): CourseItemDto | null {
  if (!state) return null;
  const items = state.blocks.flatMap((b) => b.items);
  const i = items.findIndex((x) => x.code === code);
  const next = i >= 0 ? items[i + 1] : undefined;
  return next && (next.state === 'done' || next.state === 'current') ? next : null;
}
